import React from "react";
import classNames from "classnames";

import { FolderOutlined as FolderIcon } from "@mui/icons-material";
import "./style.css";

import { UPLOADED_MEDIA_URL } from "constants/serverUrl";

export default class EntryItem extends React.Component {
  render() {
    const { is_selected, name, path, is_directory } = this.props;
    return (
      <div
        className={classNames("entry", is_selected ? "active" : "")}
        data-path={path}
        data-is-directory={is_directory}
        onClick={() =>
          typeof this.props.onClick === "function" && this.props.onClick()
        }
        onDoubleClick={() =>
          typeof this.props.onDoubleClick === "function" &&
          this.props.onDoubleClick()
        }
      >
        <div className="entry-block">
          {is_directory ? (
            <FolderIcon className="folder" />
          ) : (
            <img
              className="thumbnail"
              alt="thumbnail"
              src={`${UPLOADED_MEDIA_URL}${path}?width=50`}
            />
          )}
          <span className="name">{name}</span>
        </div>
      </div>
    );
  }
}
